import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import App from '@app';
import { Body, PageHeader, GroupList, View, Icon, Button } from '@components';
import TableInformacoes from './TableInformacoes';
import styled from 'styled-components';
import TableComandos from '@containers/Conectores/Comandos/TableComandos';
import TableFontesDados from '@containers/Conectores/FontesDados/TableFontesDados';
import TableHeaders from '@containers/Conectores/Headers/TableHeaders';
import TableLogs from '@containers/Conectores/Logs/TableLogs';
import TableRequisicoes from '@containers/Conectores/Requisicoes/TableRequisicoes';
import CadastroHorarioFuncionamento from '@containers/Conectores/HorarioFuncionamento/Cadastro';
import { setInformacao } from '@ducks/conectoresConfiguracoesInformacoes';
import { setConectoresSelecionados } from '@ducks/conectoresComandos';
import TableConexoes from '@containers/Conectores/Conexoes/TableConexoes';
import { getConfiguracao } from '@ducks/conectoresConfiguracoes';

const ComponentInformacao = styled(View)`
  margin-left: 10px;
  width: 78%;
`;

const ViewInformacoes = styled(View)`
  width: 22%;
`;

const informacoes = [
  { informacao: 'Comando', tipo: 'COMANDO', component: <TableComandos />, addUrl: '/conectores/comando/-1' },
  { informacao: 'Conexão', tipo: 'CONEXAO', component: <TableConexoes />, addUrl: '/conectores/configuracao/@id/conexao/-1' },
  {
    informacao: 'Fonte de Dados',
    tipo: 'FONTE_DADO',
    component: <TableFontesDados />,
    addUrl: '/conectores/configuracao/@id/fonte/dado/-1',
  },
  { informacao: 'Header', tipo: 'HEADER', component: <TableHeaders />, addUrl: '/conectores/configuracao/@id/header/-1' },
  {
    informacao: 'Horário de Funcionamento',
    tipo: 'HORARIO_FUNCIONAMENTO',
    component: <CadastroHorarioFuncionamento />,
  },
  { informacao: 'Log', tipo: 'LOG', component: <TableLogs /> },
  { informacao: 'Requisição', tipo: 'REQUISICAO', component: <TableRequisicoes /> },
];

export default function Configuracoes() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id, idCliente } = useParams();

  const informacao = useSelector(({ conectoresConfiguracoesInformacoes }) => conectoresConfiguracoesInformacoes.get('informacao'));
  const configuracao = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('configuracao'));

  const setConectorSelecionadoComando = () => {
    dispatch(setConectoresSelecionados([`${idCliente}-${id}`]));
  };

  useEffect(() => {
    const infoComando = informacoes.filter((info) => info.tipo === 'COMANDO')[0];
    infoComando['callAfter'] = setConectorSelecionadoComando;
    dispatch(getConfiguracao(id));
  }, [id]);

  const handleSetInformacaoOnRefresh = () => {
    const tipo = localStorage.getItem('ultimoTipoInformacaoConfiguracao');

    if (tipo) {
      const item = informacoes.filter((ds) => ds.tipo === tipo);

      if (item) {
        handleSelect(item[0]);
      }
    }
  };

  const handleSelect = (item) => {
    dispatch(setInformacao(item));
  };

  useEffect(() => {
    handleSetInformacaoOnRefresh();
  }, []);

  const handleInformacaoComponent = () => {
    if (informacao && informacao.component) {
      return informacao.component;
    } else if (informacao.tipo) {
      return <div>Sem visualização</div>;
    }
  };

  return (
    <App>
      <Body>
        <PageHeader
          title={`Conector${configuracao && configuracao.conectorIdentify ? ` - ${configuracao.conectorIdentify}` : ''}`}
          onBack={() => history.goBack()}
          extra={[
            <Button
              key='1'
              icon={<Icon.CopyOutlined />}
              onClick={() => history.push(`/conectores/configuracao/${idCliente}/${id}/duplicacao`)}
            >
              Duplicar Conector
            </Button>,
          ]}
        >
          <GroupList>
            <ViewInformacoes>
              <TableInformacoes dataSource={informacoes} />
            </ViewInformacoes>
            <ComponentInformacao>{handleInformacaoComponent()}</ComponentInformacao>
          </GroupList>
        </PageHeader>
      </Body>
    </App>
  );
}
